export const calculateProjectedAnnualGoalPercentage = (
    annualGoalPercentage: number,
    percentageOfYearPassed: number
): number => {
    if (percentageOfYearPassed <= 0) {
        return 0;
    }

    return Number(((annualGoalPercentage / percentageOfYearPassed) * 100).toFixed(1));
};
